function initPopin() {
  const dialogs = document.querySelectorAll("dialog");

  // On boucle sur toutes les dialog présentes sur la page
  for (let dialog of dialogs) {
    let dialogId = dialog.dataset.dialog;
    let btnSelector = ".btn-dialog[data-dialog=" + dialogId + "]";
    let outputSelector = "output[data-dialog=" + dialogId + "]";
    let openDialogLink = document.querySelector(btnSelector);
    let confirmBtn = dialog.querySelector(".confirmBtn");
    let outputBox = document.querySelector(outputSelector);
    let selectEl = dialog.querySelector("select");
    let closeDialogSpan = dialog.querySelector(".dialog-close");

    // Ouvre la dialog
    openDialogLink?.addEventListener('click', (event) => {
      event.preventDefault(); // Empêche le comportement par défaut du lien
      dialog.showModal(); // Affiche la dialog avec méthode native
    })

    // Ferme la dialog quand on clique à l'extérieur dela dialog
    window.addEventListener('click', (event) => {
      if (event.target == dialog) {
        dialog.close();
      }
    })

    // Ferme la dialog quand on clique sur le "X"
    closeDialogSpan?.addEventListener('click', () => {
      dialog.close();
    })

    // Ferme la boîte de dialogue avec la méthode native `close()`, qui a comme argument la valeur de retour
    confirmBtn?.addEventListener("click", (event) => {
      dialog.close(selectEl.value);
    });

    // Si la dialog est refermée en cliquant sur "annuler", ou en dehors, ou en sélentionnant "choisir", 'Pas de valeur de retour' est retourné
    // Si la dialog est refermée en cliquant sur "valider", on récupère la valeur de retour
    dialog?.addEventListener("close", () => {
      if(!outputBox) return
      outputBox.value =
          (dialog.returnValue === 'default' || dialog.returnValue === '')
              ? 'Pas de valeur de retour.'
              : `Valeur de retour : ${dialog.returnValue}.`; // Have to check for "default" rather than empty string
    });
  }
}

initPopin();